import closeIcon from "../../images/icons/close.svg";

const Modal = ({ isOpen, handleModal, children }) => {
  const handleClose = () => {
    handleModal(false);
  };

  const handleContainerClick = (e) => {
    if (e.target.classList.contains("modal-container")) {
      handleClose();
    }
  };

  return (
    isOpen && (
      <div className="modal-container" onClick={handleContainerClick}>
        <div className="modal flex-column column-start gap-4x border-radius-l shadow">
          <div className="head flex-row flex-end w-100">
            <img
              className="pointer"
              src={closeIcon}
              alt="close"
              onClick={() => handleClose()}
            />
          </div>
          <div className="content-wrapper w-100">{children}</div>
        </div>
      </div>
    )
  );
};

export default Modal;
